<div
  #overlay
  class="ad-modal-overlay"
  [hidden]="!open"
  (click)="clickOverlay($event)"
>
  <div class="ad-modal" [style.width]="width + 'px'">
    <ng-content></ng-content>
  </div>
</div>
